import React, { useState, useEffect } from "react";
import SectionHeader from "../../../components/section/SectionHeader";
import SectionTitle from "../../../components/section/SectionTitle";
import FormModal from "../../../components/modal/FormModal";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { deleteRequest, getRequest } from "../../../services/api";
import ConfirmDialog from "../../../components/dialog/ConfirmDialog";
import PromoBannerTable from "../../../components/promo-banner/PromoBannerTable";
import AddPromoBanner from "../../../components/promo-banner/AddPromoBanner";

function isAdd(location) {
  if (
    location.pathname.indexOf("/promo-banner") !== -1 &&
    location.pathname.indexOf("/create") !== -1
  ) {
    return true;
  }
  return false;
}

function isEdit(location) {
  if (
    location.pathname.indexOf("/promo-banner") !== -1 &&
    location.pathname.indexOf("/edit") !== -1
  ) {
    return true;
  }
  return false;
}

function PromoBanner() {
  const [showAddForm, setShowAddForm] = useState(false);
  const [banners, setBanners] = useState([]);
  const [bannerResponse, setBannerResponse] = useState(null);
  const [bannerToEdit, setBannerToEdit] = useState(null);

  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [bannerToDelete, setBannerToDelete] = useState(null);

  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const { id, page: pageNum } = params;

  useEffect(() => {
    getBanners();
  }, [params]);

  useEffect(() => {
    if (isAdd(location)) {
      setShowAddForm(true);
    } else if (isEdit(location)) {
      handleShowEdit();
    }
  }, [location]);

  const dismissAddForm = () => {
    setShowAddForm(false);
    setBannerToEdit(null);
    setBannerToDelete(null);
    navigate("/promo-banner", { replace: true });
  };

  const getBanners = async (page = pageNum) => {
    if (isNaN(page)) {
      page = 0;
    }
    page = page - 1;
    if (page < 0) {
      page = 0;
    }

    try {
      var path = `admin/banner`;

      const response = await getRequest(`${path}?page=${page}`, true);
      setBanners(response);
      setBannerResponse(response);
    } catch (err) {
      //console.log(err);
    }
  };

  const handleShowEdit = async () => {
    const banner = await getRequest(`admin/banner/${id}`, true);
    setBannerToEdit(banner);
    setShowAddForm(true);
  };

  const handleBannerDelete = async () => {
    try {
      await deleteRequest("admin/banner", bannerToDelete.id);
      await getBanners();
    } catch (err) {
      console.log(err);
    } finally {
      setShowDeleteConfirmation(false);
      setBannerToDelete(null);
    }
  };

  const handleConfirmationDismiss = () => {
    setShowDeleteConfirmation(false);
    setBannerToDelete(null);
  };

  const handleBannerDeleteClick = (banner) => {
    setBannerToDelete(banner);
    setShowDeleteConfirmation(true);
  };

  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded p-2">
        <div className="rounded-t mb-0 px-4 py-3 pb-8 border-0">
          <SectionHeader>
            <SectionTitle title={"Promo Banners"} />

            <Link to={"/promo-banner/create"}>
              <span className="bg-primary text-white  active:bg-primary-light font-bold uppercase text-sm px-6 py-2 rounded shadow hover:bg-primary-dark hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150">
                Add New
              </span>
            </Link>
          </SectionHeader>
        </div>

        <PromoBannerTable
          banners={banners}
          offset={0}
          onDelete={handleBannerDeleteClick}
        />
      </div>

      <FormModal
        hidden={!showAddForm}
        title={`${bannerToEdit === null ? "Add" : "Update"} Slider`}
        onDismiss={dismissAddForm}
      >
        <AddPromoBanner onDismiss={dismissAddForm} banner={bannerToEdit} />
      </FormModal>

      {bannerToDelete !== null ? (
        <ConfirmDialog
          title="Delete Banner?"
          message={`Are your sure you want to delete the banner?`}
          visible={showDeleteConfirmation}
          onAccept={handleBannerDelete}
          onDismiss={handleConfirmationDismiss}
        />
      ) : null}
    </>
  );
}

export default PromoBanner;
